<ng-select
    *ngIf="collections$ | async as collections"
    placeholder="Search by name"
    [items]="collections"
    appendTo="body"
    [addTag]="false"
    [multiple]="false"
    bindValue="id"
    bindLabel="name"
    [compareWith]="compareWith"
    [clearable]="true"
    (search)="searchInput$.next($event)"
    [typeahead]="searchInput$"
    [searchable]="true"
    [trackByFn]="trackById"
    [(ngModel)]="selectedCollection"
    (change)="selectCollection($event)"
>
    <ng-template ng-label-tmp let-item="item">
        <span>{{ item?.name }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <span>{{ item?.name }}</span>
    </ng-template>
</ng-select>
